module.exports = __webpack_public_path__ + "img/bigImg2.af409564.png";